module.exports = __webpack_public_path__ + "static/media/icon-list.584945d3.svg";